export const calcTotal = (email, pricing, discountAmount) =>
discountAmount ? (Math.floor(email * pricing) - discountAmount).toLocaleString('en')
: Math.floor(email * pricing).toLocaleString('en');
